var React = require('react');

function CodeApl (props) {
    return React.createElement("svg",props,[React.createElement("style",{"type":"text/css","key":0},"\n\t.st0{fill:none;stroke:#000000;stroke-width:6;stroke-miterlimit:10;}\n\t.st1{fill:none;stroke:#000000;stroke-width:2;stroke-miterlimit:10;}\n"),React.createElement("g",{"key":1},[React.createElement("polygon",{"points":"7.8,21 0.6,13.8 7.8,6.7 9.2,8.1 3.4,13.8 9.2,19.6 \t","key":0}),React.createElement("polygon",{"points":"20.2,21 18.8,19.6 24.6,13.8 18.8,8.1 20.2,6.7 27.4,13.8 \t","key":1}),React.createElement("rect",{"x":"4.1","y":"13","transform":"matrix(0.2832 -0.9591 0.9591 0.2832 -3.5021 23.3141)","width":"19.6","height":"2","key":2})])]);
}

CodeApl.defaultProps = {"version":"1.1","id":"Layer_1","x":"0px","y":"0px","viewBox":"0 0 28 28","style":{"enableBackground":"new 0 0 28 28"},"xmlSpace":"preserve"};

module.exports = CodeApl;

CodeApl.default = CodeApl;
